import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  getProcedimientosPss: ["payload"],
  getProcedimientosPssLoading: null,
  getProcedimientosPssSuccess: ["getProcedimientosPssData"],
  getProcedimientosPssFailure: ["getProcedimientosPssError"],

  getMedicos: ["payload"],
  getMedicosLoading: null,
  getMedicosSuccess: ["getMedicosData"],
  getMedicosFailure: ["getMedicosError"],

  actualizarPrestadorStandVirtual: ["payload"],
  actualizarPrestadorStandVirtualLoading: null,
  actualizarPrestadorStandVirtualSuccess: [
    "actualizarPrestadorStandVirtualData"
  ],
  actualizarPrestadorStandVirtualFailure: [
    "actualizarPrestadorStandVirtualError"
  ]
});

export { Types };

export default Creators;
